// src/api/authStorage.js

const AUTH_CODE_KEY = 'auth_code';
const USER_ID_KEY  = 'user_id';
const ROLES_KEY    = 'user_roles';

/**
 * Persist the current user’s auth credentials
 * @param {string} authCode 
 * @param {number} userId 
 * @param {string[]} roles 
 */
export function setCredentials(authCode, userId, roles) {
  localStorage.setItem(AUTH_CODE_KEY, authCode);
  localStorage.setItem(USER_ID_KEY, String(userId));
  localStorage.setItem(ROLES_KEY, JSON.stringify(roles));
}

/** @returns {string|null} */
export function getAuthCode() {
  return localStorage.getItem(AUTH_CODE_KEY);
}

/** @returns {number|null} */
export function getUserId() {
  const v = localStorage.getItem(USER_ID_KEY);
  return v !== null ? parseInt(v, 10) : null;
}

/** @returns {string[]} */
export function getUserRoles() {
  const r = localStorage.getItem(ROLES_KEY);
  return r ? JSON.parse(r) : [];
}

/** Clears all stored credentials */
export function clearCredentials() {
  localStorage.removeItem(AUTH_CODE_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(ROLES_KEY);
}
